import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Compass } from "lucide-react";
import { Logo, scrollToSection } from "./Reveal";

const BOUSSOLE_URL = "https://boussole.yassineabou.fr";

const LINKS = [
  { hash: "#accueil", label: "Accueil", testid: "nav-link-accueil" },
  { hash: "#methode", label: "Méthode", testid: "nav-link-methode" },
  { hash: "#accompagnement", label: "Accompagnement", testid: "nav-link-accompagnement" },
  { hash: "#qui-suis-je", label: "Mon expertise", testid: "nav-link-expertise" },
  { hash: "#resultats", label: "Résultats", testid: "nav-link-resultats" },
  { hash: "#temoignages", label: "Témoignages", testid: "nav-link-temoignages" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const go = (e, hash) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(hash);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-obsidian/85 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
        <a href="#accueil" onClick={(e) => go(e, "#accueil")} data-testid="navbar-brand-logo" className="flex items-center gap-3 shrink-0">
          <Logo />
          <span className="leading-none">
            <span className="block font-heading font-extrabold text-lg tracking-wide uppercase">Yassine Abou</span>
            <span className="block text-[10px] font-bold tracking-[0.3em] text-ember uppercase mt-0.5">Mental × Combat</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              data-testid={l.testid}
              onClick={(e) => go(e, l.hash)}
              className="text-sm font-medium text-slate-300 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/ressources"
            data-testid="nav-link-ressources"
            className="text-sm font-medium text-slate-300 hover:text-white transition-colors duration-200"
          >
            Ressources
          </a>
          <a
            href={BOUSSOLE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-link-boussole"
            className="inline-flex items-center gap-1.5 text-sm font-bold text-gold hover:text-amber-300 transition-colors duration-200"
          >
            <Compass size={15} />
            Boussole
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-contact"
            onClick={(e) => go(e, "#contact")}
            className="hidden sm:inline-flex items-center rounded-full bg-ember hover:bg-emberdark px-5 py-2.5 text-sm font-bold uppercase tracking-wide transition-colors duration-200"
          >
            Échanger avec Yassine
          </button>
          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-slate-200"
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-obsidian/95 backdrop-blur-xl px-6 py-4 flex flex-col gap-1" data-testid="nav-mobile-panel">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              data-testid={`${l.testid}-mobile`}
              onClick={(e) => go(e, l.hash)}
              className="py-3 text-base font-medium text-slate-200 border-b border-white/5"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/ressources"
            data-testid="nav-link-ressources-mobile"
            className="py-3 text-base font-medium text-slate-200 border-b border-white/5"
          >
            Ressources
          </a>
          <a
            href={BOUSSOLE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-link-boussole-mobile"
            className="py-3 text-base font-bold text-gold border-b border-white/5"
          >
            Boussole — l'application
          </a>
          <button
            data-testid="nav-cta-contact-mobile"
            onClick={(e) => go(e, "#contact")}
            className="mt-3 rounded-full bg-ember px-5 py-3 text-sm font-bold uppercase tracking-wide"
          >
            Échanger avec Yassine
          </button>
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
